// API Service
// This file centralizes all API calls and handles the base URL configuration

import axios from 'axios';
import apiConfig from '../config/apiConfig';

class ApiService {
  constructor() {
    // Create axios instance with interceptors
    this.axiosInstance = axios.create();
    this.setupInterceptors();
  }

  setupInterceptors() {
    // Request interceptor to add base URL
    this.axiosInstance.interceptors.request.use(
      (config) => {
        // If the URL is already absolute, don't modify it
        if (config.url.startsWith('http')) {
          return config;
        }
        
        // Convert relative URL to absolute using our config
        config.url = apiConfig.getFullURL(config.url);
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Response interceptor for error handling
    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        // Handle common errors here if needed
        console.error('API Error:', error);
        return Promise.reject(error);
      }
    );
  }

  // GET request
  get(url, config = {}) {
    return this.axiosInstance.get(url, config);
  }

  // POST request
  post(url, data = {}, config = {}) {
    return this.axiosInstance.post(url, data, config);
  }

  // PUT request
  put(url, data = {}, config = {}) {
    return this.axiosInstance.put(url, data, config);
  }

  // DELETE request
  delete(url, config = {}) {
    return this.axiosInstance.delete(url, config);
  }

  // Method to update the base URL at runtime
  updateBaseURL(newBaseURL) {
    apiConfig.setBaseURL(newBaseURL);
    console.log(`API base URL updated to: ${newBaseURL}`);
  }

  // Method to get current base URL
  getBaseURL() {
    return apiConfig.getBaseURL();
  }
}

// Create and export a singleton instance
const apiService = new ApiService();

export default apiService;
